import { Component, OnInit,Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-category-popup',
  templateUrl: './category-popup.component.html',
  styleUrls: ['./category-popup.component.scss']
})
export class CategoryPopupComponent implements OnInit {
  CategoryForm : FormGroup;
  submitpayload: any;
  casteCategoryList: any;
  dialogRef: MatDialogRef<any>;
  APIService: any;
  CasteCategoryfordelete;
  editButton = false;
  submitButton = true;
  deleteButton: boolean;
  isread = false;
  isreaddelete = false;
  constructor( private fb: FormBuilder,
    public umsService: UmsService,
    private dialogRef2: MatDialogRef<CategoryPopupComponent>,
    private modalPopupService: ModalpopService,
    private httpClient: HttpClient,
    public router: Router,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { this.APIService = environment.serviceUrl;}

  ngOnInit(): void {
    this.CategoryForm = this.fb.group({
      CdCode: new FormControl('',[Validators.required]),
      CdDesc: new FormControl('',[Validators.required]),
      CdSeq: new FormControl(''),
      CdActive: new FormControl(''),
      CdProc: new FormControl(''),
      CdType: new FormControl(''),

    });
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.deletee(this.data.selected);
    } else {
      // alert(this.data.key)
    }
  }

  getCasteCategoryData() {
    // this.spinner.show();
    const payload = {};
    this.umsService.getCasteCategoryData(payload).subscribe(res => {
      this.casteCategoryList = res.data;
      // this.spinner.hide();
    });
  }

  submit() {
    if (this.CategoryForm.invalid) {
      this.CategoryForm.get('CdCode').markAsTouched();
      this.CategoryForm.get('CdDesc').markAsTouched();
      return;
    } else {
      this.createCasteCategory();
    }

  }



  createCasteCategory() {
    this.spinner.show();
    this.submitpayload = this.CategoryForm.value;
    this.submitpayload['CdCode'] = this.submitpayload['CdCode'];
    this.submitpayload['CdDesc'] = this.submitpayload['CdDesc'];
    this.submitpayload['CdSeq'] = '';
    this.submitpayload['CdActive'] = '';
    this.submitpayload['CdProc'] = '';
    this.submitpayload['CdType'] = 'CS';
    this.umsService.addCasteCategory(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-box-open';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  update() {
    if (this.CategoryForm.invalid) {
      this.CategoryForm.get('CdCode').markAsTouched();
      this.CategoryForm.get('CdDesc').markAsTouched();
      return;
    } else {
      this.updateCasteCategory();
    }
  }

  updateCasteCategory() {
    this.spinner.show();
    // let submitpayload = this.CasteForm.value;
    this.submitpayload = this.CategoryForm.value;
    this.submitpayload['CdCode'] = this.submitpayload['CdCode'];
    this.submitpayload['CdDesc'] = this.submitpayload['CdDesc'];
    this.submitpayload['CdSeq'] = this.CategoryForm.value.CdSeq;
    this.submitpayload['CdActive'] = '';
    this.submitpayload['CdProc'] = '';
    this.submitpayload['CdType'] = 'CS';
    this.umsService.updateCasteCategory(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-box-open';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }
  prepopulation(id) {
    const payload = {};
    payload['CdCode'] = id.CdCode;
    this.umsService.getCasteCategoryData(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        this.editButton = true;
        // this.isreadonly = true;
        this.isread = true;
        this.isreaddelete = false;
        this.submitButton = false;
        this.submitButton = false;
        this.deleteButton = false;
        this.CategoryForm = this.fb.group({
          CdCode: new FormControl(data.CdCode, [Validators.required]),
          CdDesc: new FormControl(data.CdDesc, [Validators.required]),
          CdActive: new FormControl(data.CdActive),
          CdProc: new FormControl(data.CdProc),
          CdType: new FormControl(data.CdType),
          CdSeq: new FormControl(data.CdSeq),
        });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  deletedata(id) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        CdCode: id.CdCode,
        CdDesc: id.CdDesc,
        CdSeq: id.CdSeq,
        CdActive: id.CdActive,
        CdProc: id.CdProc,
        CdType: id.CdType,
      },
    };
    this.httpClient.delete(this.APIService + '/masters/CasteCategory', options)
      .subscribe((s) => {
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ngOnInit();
          this.dialogRef2.close()
        });
      });

  }


  deletee(k) {
    // this.list = false;
    this.getCasteCategoryData();
    const payload = {};

    payload['CdCode'] = k.CdCode;
    this.umsService.getCasteCategoryData(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status) {
        this.editButton = false;
        this.submitButton = false;
        // this.isreadonlydel = true;
        this.isreaddelete = true;
        this.deleteButton = true;
        this.CategoryForm = this.fb.group({
          CdCode: new FormControl(data.CdCode, [Validators.required]),
          CdDesc: new FormControl(data.CdDesc, [Validators.required]),
          CdSeq: new FormControl(data.CdSeq),
          CdActive: new FormControl(data.CdActive),
          CdProc: new FormControl(data.CdProc),
          CdType: new FormControl(data.CdType),
        });
        this.CasteCategoryfordelete = this.CategoryForm.value;
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
    // } else {
    //   this.list = true;
    // }
  }
  openConformationModalBox() {
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.deletedata(this.CasteCategoryfordelete);
      } else {
        // this.ngOnInit();
      }
    });
  }

  editdata(e, k) {
    if (e === 'true') {
      // this.list = false;
      // this.isreadonly = false;
      this.getCasteCategoryData();
      // this.CountryForm = k;
      this.prepopulation(k);
    } else {
      // this.list = true;
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}
